PJQ.views.templates = {};
PJQ.views.templates.TemplateManagement = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Template-Management'),
		templateType: null
	},
	events: {
		'click .btn-add-template': 'addTemplate',
		'click .btn-edit-template': 'editClicked',
		'click .btn-delete-template': 'deleteClicked'
	},
	beforeFirstRender: function () {
		if(!this.options.collection) {
			this.collection = new PJQ.collections.schedule.Templates();
		}
		else{
			this.collection = this.options.collection
		}
		this.listenTo(this.collection, 'fetch', this.render);
		this.collection.fetch();
	},
	renderData: function () {
		return {
			collection: this.collection,
			templateType: this.options.templateType
		};
	},
	afterRender: function () {
		if (this.collection == null || !this.collection.isFetched) {
			return;
		}
		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: this.$('.templates-table'),
			isHideSearch: true,
			data: this.collection.models,
			rowId: "cid",
			order: [0, 'asc'],
			pageLength: 20,
			language: {
				zeroRecords: 'Click "Add" to create a new Template'
			},
			onRowDoubleClick: _.bind(function (row) {
				this.editTemplate(row.data());
			}, this),
			contextMenuOptions: {
				actions: [
					{
						name: 'Edit',
						onClick: _.bind(function (row) {
							this.editTemplate(row.data());
						}, this)
					},
					{
						name: 'Delete',
						isDanger: true,
						onClick: _.bind(function (row) {
							this.deleteTemplate(row);
						}, this)
					}
				]
			},
			columns: [
				{
					"data": "attributes.name",
					"title": "Name"
				}, {
					"data": "",
					"title": "",
					"orderable": false,
					"searchable": false,
					"render": _.bind(function () {
						return '<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-info btn-edit-template wd-30p mr-1"><i class="fal fa-pencil"></i><button type="button" class="btn btn-danger btn-delete-template wd-30p"><i class="fal fa-trash-alt"></i></button></button></div>'
					}, this),
					"width": "80px"
				}
			]
		});
	},
	addTemplate: function () {
	},
	editClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr')),
			template = row.data();

		this.editTemplate(template);
	},
	editTemplate: function (template) {
	},
	deleteClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr'));
		this.deleteTemplate(row);
	},
	deleteTemplate: function (row) {
		let template = row.data();
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this template?",
			onDelete: _.bind(function () {
				this.collection.remove(template);
				template.destroy();
				this.dataTable.removeRow(row);
			}, this)
		});
	}
});

PJQ.views.templates.NewTemplateModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-New-Template'),
		minWidth: '500px',
		onSave: _.noop,
		isSubmittal: false
	},
	events: {
		'keyup .input-template-name': 'templateNameChanged',
		'click .btn-save': 'save'
	},
	beforeModalCreated: function () {
		if(!this.options.model){
			this.model = new PJQ.models.schedule.Template();
		}
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model
		};
	},
	afterRender: function () {
		this.$('.input-template-name').focus();
	},
	templateNameChanged: function (e) {
		let isValid = _.size(this.$('.input-template-name').val()) > 0;
		this.$('.btn-save').prop('disabled', !isValid);
		if (isValid && e.keyCode === 13) {
			this.save();
		}
	},
	save: function () {
		let templateName = this.$('.input-template-name').val();
		if (_.size(templateName) === 0) {
			return;
		}

		new PJQ.Loader(this.$('.modal-content'));
		this.model.save({
			name: templateName
		}, {
			success: _.bind(function () {
				this.removeModal();
				if (typeof this.options.onSave === 'function') {
					this.options.onSave(this.model);
				}
			}, this)
		});
	}
});
